import axios from 'axios'
import HTTP from './http'

export default {
    getCancellationRequests: (payload) => axios.get(HTTP.CANCELLATION_REQUESTS, { params: { ...payload } }),
    exportCancellationRequests: payload =>
        axios.get(HTTP.CANCELLATION_REQUESTS_EXPORT, { params: { ...payload } }),
    postCancellationRequest: (payload) => axios.post(HTTP.CANCELLATION_REQUESTS, { params: { ...payload } }),
    updateCancellationRequest: (payload) => axios.put(HTTP.CANCELLATION_REQUESTS, { ...payload }),
    sendCancelMail: payload => axios.post(HTTP.SEND_CANCEL_MAIL, { ...payload }),
    generateCancellationReport: (payload) => axios.post(HTTP.CANCELLATION_REQUESTS_REPORT, { ...payload }),
    getComissionsForCancellationReq: (payload) => axios.get(HTTP.COMMISSIONS_FOR_CANCELLATION, { params: { ...payload } })
}
